<template>
  <div class="m-portrait">
    <Search :renderData="renderData" :formData="form" @onSearch="onSearch" ></Search>
    <div class="fun-btn-box">
      <auth-button auth="member:config:portrait:create">
        <el-button type="primary" class="fun-btn mr10" @click="onAdd" >+ 创建画像</el-button>
      </auth-button>
      <auth-button auth="member:level:batch:update">
        <el-button type="default" class="fun-btn mr10" @click="levelUpdate" >等级调整</el-button>
      </auth-button>
      <auth-button auth="member:point:batch:update">
        <el-button type="default" class="fun-btn mr10" @click="integralUpdate" >积分调整</el-button>
      </auth-button>
      <auth-button auth="member:portrait:label">
        <el-button type="default" class="fun-btn mr10" @click="addLabel" >打标签</el-button>
      </auth-button>
    </div>
    <Table
      :loading="loading"
      :tableThData="tableThData"
      :tableTrData="tableTrData"
      :limit="limit"
      :total="total"
      :offset="offset"
      v-on:handleSizeChange="handleSizeChange"
      v-on:handleCurrentChange="handleCurrentChange"
      :selection="true"
      @getSelectData="getSelectData"
    >
      <template #name="{ row }">{{ row.name }}</template>
      <!-- <template #number="{ row }">{{ row.number }}</template> -->
      <template #created="{ row }">{{ row.created ? $moment(row.created).format('YYYY/MM/DD HH:mm:ss') : '' }}</template>
      <template #operation="{ scope }">
        <!-- <el-button type="text" @click="exportMemberByPortrait(scope.row)" >导出会员</el-button > -->
        <auth-button auth="member:config:portrait:update">
          <el-button type="text" @click="edit(scope.row)">编辑</el-button>
        </auth-button>
        <auth-button auth="member:config:portrait:delete">
          <el-button type="text" class="error ml10" @click="deleteRow(scope.row)">删除</el-button>
        </auth-button>
      </template>
    </Table>
    <Dialog :maskClose="false" :dialogShow="levelDialogShow" title="等级调整" @maskClick="() => {levelDialogShow = false}">
      <template>
        <div class="level-update">
          <el-radio-group v-model="levelForm.type">
            <el-radio label="up">升等级</el-radio>
            <el-radio label="down">降等级</el-radio>
          </el-radio-group>
          <el-form :hide-required-asterisk="true" ref="levelForm" :model="levelForm" label-width="80px">
            <el-row>
              <el-col :span="21">
                <el-form-item :rules="[{ required: true, message: '等级不能为空'},]" label="等级调整" prop="level">
                  <el-input v-model="levelForm.level" type="text" oninput="value=value.replace(/[^1-9]/g,'')" maxlength="1"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="3">
                <div class="tips">级</div>
              </el-col>
            </el-row>
             <el-row>
              <el-col :span="24">
              <el-form-item label="备注" prop="remark"  :rules="[{ required: true, message: '备注不能为空'}]" >
                  <el-input  type="textarea" rows="6" v-model="levelForm.remark"  placeholder="请输入备注" maxlength="2000" show-word-limit  />
              </el-form-item>
              </el-col>
            </el-row>
           
          </el-form>
          <div class="button-div">
            <el-row class="button-div-row">
              <el-button type="default" class="cancel" @click="() => {levelDialogShow = false}">取消</el-button>
              <el-button type="primary" :loading="levelDialogLoading" class="determine" @click="determineLevel">确定</el-button>
            </el-row>
          </div>
        </div>
      </template>
    </Dialog>
    <Dialog :maskClose="false" :dialogShow="integralDialogShow" title="积分调整" @maskClick="() => {integralDialogShow = false}">
      <template>
        <div class="integral-update">
          <el-radio-group v-model="integralForm.type">
            <el-radio label="up">增加积分</el-radio>
            <el-radio label="down">扣减积分</el-radio>
          </el-radio-group>
          <el-form :hide-required-asterisk="true" ref="integralForm" :model="integralForm" label-width="80px">
            <el-row>
              <el-col :span="21">
                <el-form-item label="积分调整" prop="points" :rules="[{ required: true, message: '积分不能为空'},]">
                  <el-input v-model="integralForm.points" type="text" oninput="value=value.replace(/[^\d]/g,'')"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="3">
                <div class="tips">分</div>
              </el-col>
            </el-row>
          </el-form>
          <div class="button-div">
            <el-row class="button-div-row">
              <el-button type="default" class="cancel" @click="() => {integralDialogShow = false}">取消</el-button>
              <el-button type="primary" :loading="integralDialogLoading"  class="determine" @click="determineIntegral">确定</el-button>
            </el-row>
          </div>
        </div>
      </template>
    </Dialog>
    <Dialog :maskClose="false" :dialogShow="dialogShow" title="新增标签">
      <template>
        <div class="add-label">
          <el-form :hide-required-asterisk="true" ref="labelForm" :model="labelForm" label-width="80px">
            <el-row>
              <el-col :span="24">
                <el-form-item label="选择标签" prop="labelId" :rules="[{ required: true, message: '标签不能为空'},]">
                  <el-select filterable v-model="labelForm.labelId" multiple placeholder="请选择标签">
                    <el-option
                      v-for="(item, index) in labelOptions"
                      :key="index"
                      :label="item.name"
                      :value="item.id">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <div class="button-div">
            <el-row class="button-div-row">
              <el-button type="default" class="cancel" @click="() => {dialogShow = false}">取消</el-button>
              <el-button type="primary" :loading="dialogLoading"  class="determine" @click="determine">确定</el-button>
            </el-row>
          </div>
        </div>
      </template>
    </Dialog>
  </div>
</template>

<script>
import AuthButton from '@/components/AuthButton'
import Search from "@/components/Search/index"
import Table from "@/components/Table/index"
import Dialog from "@/components/Dialog/index"
import { api_getListPortrait, api_putULevels, api_putUPoints, api_deletePortrait, api_postPortraitLabel} from '@/api/member'
import { api_getListLabel } from '@/api/common'
import tableList from '@/mixins/tableList'
export default {
  name: "mPortrait",
  mixins: [tableList],
  components: {
    AuthButton,
    Search,
    Table,
    Dialog
  },
  data() {
    return {
      renderData: [
        {
          label: "画像名称",
          placeholder: "请输入画像名称",
          type: "input",
          key: "name",
        }
      ],
      form: {
        name: "",
      },
      tableThData: [
        { prop: "name", label: "画像名称", minWidth: "120", },
        // { prop: "number", label: "会员人数", minWidth: "130", },
        { prop: "created", label: "创建时间", minWidth: "260", },
        { prop: "operation", label: "操作", minWidth: "160", },
      ],
      levelDialogShow: false,
      integralDialogShow: false,
      levelDialogLoading: false,
      integralDialogLoading: false,
      dialogShow: false,
      dialogLoading: false,
      labelForm: {
        labelId: []
      },
      labelOptions: [],
      levelForm: {
        type: 'up',
        level: '',
        ids: [],
        remark:''
      },
      integralForm: {
        type: 'up',
        points: '',
        ids: []
      },
      selection: []
    };
  },
  created () {
    this.getListLabel()
  },
  methods: {
    async getListLabel() {
      this.labelOptions = await api_getListLabel()
    },
      // 禁用选项
    checkSelectable_all(row) {
      return true
    },
    onAdd () {
      this.$router.push({
        path: '/member/portrait/create'
      })
    },
    // 获取表格列表数据
    async getList () {
      this.loading = true
      const params = {
        ...this.form,
        offset: this.offset,
        limit: this.limit,
      }
      this.$router.push({query: params})
      const data = await api_getListPortrait({name: this.form.name, limit: this.limit, offset: this.offset})
      this.tableTrData = data.list || []
      this.total = data.count
      this.loading = false
    },
    // 导出
    exportPortrait () {
    },
    // 编辑
    edit (row) {
      this.$router.push({
        path: '/member/portrait/create?id=' + row.id
      })
    },
    // 删除
    deleteRow (row) {
      this.$baseConfirm(
        '是否确认删除？',
        {
          title: '提示',
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          showClose: false,
          type: 'warning',
        },
        async () => {
          await api_deletePortrait({id: row.id})
          this.$baseMessage('删除成功', 'success')
          this.getList()
        }
      )
    },
    determine () {
      this.$refs.labelForm.validate(async (valid) => {
        if (valid) {
          this.dialogLoading = true
          try {
            const data = await api_postPortraitLabel({...this.labelForm})
            this.dialogLoading = false
            this.dialogShow = false
            this.getList()
            this.alertMsg(data, 'label')
          } catch (error) {
            this.dialogLoading = false
          }
        } else {
          return false
        }
      })
    },
    // 点击调整等级确认按钮
    determineLevel () {
      this.$refs.levelForm.validate(async (valid) => {
        if (valid) {
          this.levelDialogLoading = true
          try {
            this.levelForm.level = this.levelForm.level*1
            const data = await api_putULevels({...this.levelForm})
            this.levelDialogLoading = false
            this.levelDialogShow = false
            this.getList()
            this.alertMsg(data, 'level')
          } catch (error) {
            this.levelDialogLoading = false
          }
        } else {
          return false
        }
      })
    },
    // 点击调整积分确认按钮
    determineIntegral () {
      this.$refs.integralForm.validate(async (valid) => {
        if (valid) {
          this.integralDialogLoading = true
          try {
            this.integralForm.points = this.integralForm.points*1
            const data = await api_putUPoints({...this.integralForm})
            this.integralDialogLoading = false
            this.integralDialogShow = false
            this.getList()
            this.alertMsg(data, 'integral')
          } catch (error) {
            this.integralDialogLoading = false
          }
        } else {
          return false
        }
      })
    },
    addLabel () {
      if (this.selection.length > 0) {
        this.dialogShow = true
        this.labelForm.portraitId = this.selection.map((item) => {
          return item.id
        })
      }else{
        this.$baseMessage('请选择需要操作的数据', 'error')
      }
    },
    // 点击调整等级按钮
    levelUpdate () {
      if (this.selection.length > 0) {
        this.levelDialogShow = true
        this.levelForm = {
          type: 'up',
          level: '',
          ids: '',
          remark:''
        }
        this.levelForm.ids = this.selection.map((item) => {
          return item.id
        })
      }else{
        this.$baseMessage('请选择需要操作的数据', 'error')
      }
    },

    // 点击调整积分
    integralUpdate () {
      if (this.selection.length > 0) {
        this.integralDialogShow = true
        this.integralForm = {
          type: 'up',
          points: '',
          ids: ''
        }
        this.integralForm.ids = this.selection.map((item) => {
          return item.id
        })
      }else{
        this.$baseMessage('请选择需要操作的数据', 'error')
      }
    },
    getSelectData (selection) {
      this.selection = selection
    },
    exportMemberByPortrait () {

    },
    alertMsg (data, type) {
      // if (data.success == 0) {
      //   this.$baseMessage('操作失败', 'error')
      // } else if(data.fail == 0) {
      //   this.$baseMessage('操作成功', 'success')
      // } else {
      //   this.$baseMessage(`操作成功${data.success}条数据，失败${data.fail}条数据`, 'warning')
      // }
      let msg = ''
      switch (type) {
        case 'label':
          msg = `当前打标签成功用户数为：${data.success}人`
          break;
        case 'level':
          msg = `当前等级调整成功用户数为：${data.success}人`
          break;
        case 'integral':
          msg = `当前积分调整成功用户数为：${data.success}人`
          break;
      }
      this.$baseMessage(msg, 'success')
    }
  },
  computed: {},
  watch: {
    dialogShow: {
      handler(newValue, oldValue) {
        if (!newValue) {
          this.labelForm = {
            labelId: []
          }
        }
      },
    }
  }
};
</script>
<style lang="scss" scoped>
.m-portrait {
  width: 100%;
  padding: 0 30px;
  box-sizing: border-box;
  .fun-btn-box {
    margin-top: 20px;
  }
  .level-update, .integral-update{
    margin-top: 22px;
    ::v-deep{
      .el-radio__label{
        font-size: 14px;
        font-weight: 400;
        color: #333333;
        line-height: 20px;
      }
      .el-radio__input.is-checked + .el-radio__label{
        color: #05C8AF;
      }
      .el-form{
        margin-top: 33px;
        .el-form-item__label{
          color: #333;
          font-size: 16px;
        }
        .el-input{
          border-radius: 2px;
          font-size: 16px;
          .el-input__inner{
            background: #F2F3F5;
            border: 0;
          }
          .el-input__inner:focus{
            background: #fff;
            border: 1px solid #05C8AF;
          }
        }
        .el-input.is-focus{
          .el-input__inner{
            background: #fff;
          }
        }
        .tips{
          font-size: 16px;
          font-weight: 400;
          color: #333333;
          line-height: 40px;
          margin-left: 20px
        }
      }
    }
    .button-div{
      overflow: hidden;
      float: right;
      margin-top: 33px;
      button{
        border: 0;
        width: 110px;
        height: 40px;
        border-radius: 2px;
        font-size: 16px;
      }
      .cancel{
        background: #F2F3F5;
        color: #666666;
      }
    }
  }
  .add-label{
    margin-top: 22px;
    ::v-deep{
      .el-form{
        margin-top: 33px;
        .el-form-item__label{
          color: #333;
          font-size: 16px;
        }
        .el-input{
          border-radius: 2px;
          font-size: 16px;
          .el-input__inner{
            background: #F2F3F5;
            border: 0;
          }
          .el-input__inner:focus{
            background: #fff;
            border: 1px solid #05C8AF;
          }
        }
        .el-input.is-focus{
          .el-input__inner{
            background: #fff;
          }
        }
      }
    }
    .el-select{
      width: 100%;
    }
    .button-div{
      overflow: hidden;
      float: right;
      margin-top: 33px;
      button{
        border: 0;
        width: 110px;
        height: 40px;
        border-radius: 2px;
        font-size: 16px;
      }
      .cancel{
        background: #F2F3F5;
        color: #666666;
      }
    }
  }
  ::v-deep{
    .Dialog{
      .content{
        min-height: 280px;
      }
    }
  }
}
</style>
